import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import isValid from "date-fns/isValid";

export const PREORDER_SHIPPING_ATTRIBUTE_KEY = "_shipping";

export function getLineAttribute(line, key) {
  const attributes = line?.attributes;
  if (!attributes?.length) return null;

  const match = attributes.find((attr) => attr.key === key);
  return match?.value ?? null;
}

export function formatPreorderDispatchDate(raw) {
  if (!raw) return null;

  try {
    const date = parseISO(raw);
    if (isValid(date)) {
      return format(date, "do MMMM");
    }
  } catch {
    // fall through to raw value
  }

  const fallback = new Date(raw);
  if (isValid(fallback)) {
    return format(fallback, "do MMMM");
  }

  return raw;
}

export function getEstimatedDeliveryLabel(line) {
  const dispatchDate = getLineAttribute(line, PREORDER_SHIPPING_ATTRIBUTE_KEY);
  if (!dispatchDate) return null;

  const formatted = formatPreorderDispatchDate(dispatchDate);
  return formatted ? `Estimated Delivery ${formatted}` : null;
}

export function formatPreorderLongDate(raw) {
  if (!raw) return null;

  try {
    const date = parseISO(raw);
    if (isValid(date)) {
      return format(date, "do MMMM yyyy");
    }
  } catch {
    // fall through
  }

  const fallback = new Date(raw);
  if (isValid(fallback)) {
    return format(fallback, "do MMMM yyyy");
  }

  return raw;
}

export function buildPreorderDispatchLabel(estDispatchDate) {
  const formatted = formatPreorderLongDate(estDispatchDate);
  if (!formatted) return null;

  return `Pre-Order | Expected Dispatch: ${formatted}`;
}

export function getPreorderDispatchDate(estDispatchDate) {
  return formatPreorderLongDate(estDispatchDate);
}

export function getPreorderDispatchFallback(description) {
  if (!description) return null;

  const match = description.match(/Expected Dispatch:\s*(.+)/i);
  if (match) {
    return `Expected Dispatch: ${match[1].trim()}`;
  }

  return description;
}
